import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";

export default function TechRiderLink({
  artistId,
  bookingId,
  filename,
  className = "btn btn-ghost btn-sm",
  testId = "tech-rider-link",
  label = "View Tech Rider PDF",
  onUnauthenticated,
}) {
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState("");

  const openPdf = async () => {
    setError("");
    if (onUnauthenticated) {
      const shouldOpen = onUnauthenticated();
      if (shouldOpen === false) return;
    }
    const previewWindow = window.open("about:blank", "_blank");
    if (!previewWindow) {
      setError("Allow pop-ups to preview the Tech Rider PDF.");
      return;
    }
    previewWindow.opener = null;
    setOpening(true);
    try {
      const path = bookingId
        ? `/bookings/${encodeURIComponent(bookingId)}/tech-rider`
        : `/artist/tech-rider/${encodeURIComponent(artistId)}/download`;
      const response = await api.get(path, { responseType: "blob" });
      const pdfUrl = URL.createObjectURL(response.data);
      previewWindow.location.href = pdfUrl;
    } catch (requestError) {
      previewWindow.close();
      setError(`Could not open the Tech Rider PDF: ${formatApiError(requestError)}`);
    } finally {
      setOpening(false);
    }
  };

  return (
    <div className="tech-rider-link">
      <button
        type="button"
        className={className}
        onClick={openPdf}
        disabled={opening}
        data-testid={testId}
      >
        {opening ? "Opening Tech Rider…" : label}
      </button>
      {error && <div className="text-muted fs-11 mt-8" role="alert">{error}</div>}
      {filename && <div className="text-muted fs-11 mt-4">{filename}</div>}
    </div>
  );
}
